module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/question-87f15f94301be080128e611dc3e813dc.svg";